import { Validators } from '@angular/forms';

export const forgotPasswordFields = [
  {
    type: 'input',
    label: 'Username',
    name: 'username',
    placeholder: 'Username or Email',
    validation: [Validators.required],
  },
  {
    label: 'Submit',
    name: 'submit',
    cssClass: 'outlined',
    type: 'button',
  },
];
